import React from 'react';
import StatusPill, { PillTone } from '../../components/StatusPill';

// The NCR enums in the pill's vocabulary. Shared by the table cells and the
// detail-modal header so the two cannot drift.
const tone: Record<string, PillTone> = {
  // status
  Open: 'warning',
  'In Progress': 'info',
  Resolved: 'success',
  Closed: 'neutral',
  // severity
  Minor: 'info',
  Major: 'warning',
  Critical: 'danger',
  // type
  Internal: 'neutral',
  External: 'complete',
};

/** Renders an NCR enum value (type / status / severity) as a status pill. */
export const badge = (value: string | null | undefined): React.ReactElement => {
  if (!value) return <span className="text-muted">—</span>;
  return <StatusPill label={value} tone={tone[value] ?? 'neutral'} />;
};
